import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const API = process.env.REACT_APP_BACKEND_URL + '/api';
const SESSION_KEY = '_en_visit_session';

/** Fire one site-visit ping per page change. Visitor identity is anonymized
 *  server-side (IP last-octet zeroed + UA hash + day salt). No PII collected. */
export default function useSiteVisitTracking() {
  const { pathname } = useLocation();
  const lastPathRef = useRef(null);

  useEffect(() => {
    if (!pathname || lastPathRef.current === pathname) return;
    lastPathRef.current = pathname;

    // Skip master/admin/dashboard internal routes — they aren't public traffic
    if (pathname.startsWith('/master') || pathname.startsWith('/dashboard') || pathname.startsWith('/admin')) {
      return;
    }

    // Throttle: only one ping per 30 minutes per session per path
    let session = {};
    try {
      session = JSON.parse(sessionStorage.getItem(SESSION_KEY) || '{}');
    } catch { /* fresh */ }
    const now = Date.now();
    const last = session[pathname] || 0;
    if (now - last < 30 * 60 * 1000) return;

    session[pathname] = now;
    try { sessionStorage.setItem(SESSION_KEY, JSON.stringify(session)); } catch {}

    // Fire & forget
    fetch(`${API}/site-visits/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ page: pathname }),
      keepalive: true,
    }).catch(() => {});
  }, [pathname]);
}
